import { useQuery } from '@tanstack/react-query'

import { getPaymentRequestEvidenceRecordFile } from '@src/api'
import { DefaultApiGetPaymentRequestEvidenceRecordFileRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchPaymentRequestEvidenceRecordFile = (
  params: DefaultApiGetPaymentRequestEvidenceRecordFileRequest
) => {
  const { axiosInstance } = useAxios()
  axiosInstance.defaults.responseType = 'arraybuffer'

  return useQuery({
    enabled:
      !!params.organizationId &&
      !!params.paymentRequestId &&
      !!params.evidenceId &&
      !!params.recordId,
    queryFn: () => getPaymentRequestEvidenceRecordFile(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_PAYMENT_REQUEST_EVIDENCE_RECORD_FILE,
      params,
    ],
  })
}
